import { css } from 'linaria';

export const mediaMoreThenMobileX2 = `
only screen and (-webkit-min-device-pixel-ratio: 2)      and (min-width: 768px),
only screen and (   min--moz-device-pixel-ratio: 2)      and (min-width: 768px),
only screen and (     -o-min-device-pixel-ratio: 2/1)    and (min-width: 768px),
only screen and (        min-device-pixel-ratio: 2)      and (min-width: 768px),
only screen and (                min-resolution: 192dpi) and (min-width: 768px),
only screen and (                min-resolution: 2dppx)  and (min-width: 768px)
`;

export const mediaMobileX2 = `
only screen and (-webkit-min-device-pixel-ratio: 2)      and (max-width: 767px),
only screen and (   min--moz-device-pixel-ratio: 2)      and (max-width: 767px),
only screen and (     -o-min-device-pixel-ratio: 2/1)    and (max-width: 767px),
only screen and (        min-device-pixel-ratio: 2)      and (max-width: 767px),
only screen and (                min-resolution: 192dpi) and (max-width: 767px),
only screen and (                min-resolution: 2dppx)  and (max-width: 767px)
`;

export const mediaGallery = css`
  user-select: none;
  @media screen and (min-width: 1024px) {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
    min-height: 600px;
  }
`;
